import React, { useContext, useEffect, useState } from 'react'
import Button from "../buttons/Button";
import { BiMessageDetail, BiMessageAltDetail  } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import 'animate.css';
import { ThemeContext } from '../../theming';
import ClickAwayListener from 'react-click-away-listener';
import { DecryptData } from '../../helpers/encrypt';
import useStorage from '../../helpers/useStorage';
import { getPublicKey } from '../../helpers/autoAtencionHelpers';
import { AUTOATENCIONAPI, PORTALSAPI } from '../../helpers/url';
import { api } from '../../helpers/api';
import Loading from '../loading/Loading';
import Laptop from "../../assets/images/laptop-confirmada.png";
import { Col, Modal, ModalBody, Row } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';
import CustomButton from '../buttons/Button';
import { TextColored } from '../typography';

const initState = {
    "nombre_ejecutivo":'',
    "titulo": '',
    "subtitulo": '',
    "opcion": '',
    "opcion1": ''
}

const steps = {
    1: 'Selección de facturas',
    2: 'Resumen de Operación',
    3: 'Cuenta de destino',
    4: 'Carga de archivos'
}

export const Modalhelper = ({
    step 
}) => {

    const [state, setState] = useState(initState)
    const [showLoading, setShowLoading] = useState({ display: "none" });
    const [show, setShow] = useState(false);

    const app = useContext(ThemeContext);
    const [ showmodal, setModal ] = useState(false);
    const [{ idcontacto, rut, nombres, idcliente }] = useStorage("user", {}, "local");
    const [parametros] = useStorage("parametros_comerciales", {}, "session");
    const [nombre_ejecutivo] = useStorage("nombre-ejecutivo", {}, "session");

    useEffect(()=>{
        // console.log('RUT', rut)
        obtenerNombreJecutivo();
    },[])

    const obtenerNombreJecutivo = async()=>{
        const publicKey = await getPublicKey();
        const nombreEjecutivo =  decodeURIComponent(DecryptData(nombre_ejecutivo, publicKey))
        setState({
            "nombre_ejecutivo":nombreEjecutivo,
            "titulo": parametros["PAA: BOTON AYUDA - TITULO"],
            "subtitulo": parametros["PAA: BOTON AYUDA - SUBTITULO"],
            "pregunta": parametros["PAA: BOTON AYUDA - PREGUNTA"],
            "respuesta": parametros["PAA: BOTON AYUDA - RESPUESTA"],
        })
        
    }

    const handleClickejecutivo = async()=>{
        try{
            setModal(!showmodal);
            setShowLoading({ display: "block" });
            const publicKey = await getPublicKey();
            const newRut = encodeURIComponent(DecryptData(rut, publicKey))
            const reps = await api.get(AUTOATENCIONAPI.GET.BOTONAYUDA+`/${encodeURIComponent(steps[step])}/${newRut}/${idcliente}` )
            setShow(true)
        }catch(e){
            console.log('e',e)
        }finally{
            setShowLoading({ display: "none" });
            setShow(false)
        }
    }

  return (
    <>
      { showmodal &&
      <ClickAwayListener onClickAway={()=>setModal(false)}>

        <div className='modal-helper'>
            {/* HEAD  */}
            <div style={{
                background:app.theme.primary, 
                width: '100%',
                padding: '18px',
                borderTopLeftRadius: '0.6rem',
                borderTopRightRadius: '0.6rem',
                borderBottom: '2px solid #000',
            }}>

                <div className='d-flex align-items-center' style={{ gap: '0.8rem' }}>

                    <div 
                        className='d-flex align-items-center justify-content-center'
                        style={{
                            borderRadius: '50%',
                            width: '20%',
                            background: 'white',
                            height: '70px',
                            border: '2px solid #ccc'
                        }}
                    >
                        <BiMessageAltDetail style={{ color: app.theme.primary}} size={50}/>
                    </div>

                    <div style={{ width: '80%' }} className='d-flex flex-column align-items-center text-center'>
                        <h4>{ state?.titulo }</h4>
                        <p>{ state?.subtitulo }</p>
                    </div>

                </div>

            </div>

            {/* BODY  */}
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ gap: '1rem', height: '300px' }}>

                {/* <ul class="list-group" style={{ width: '330px', border: `1px solid ${app.theme.primary}`}}>
                    <li class="list-group-item text-center" style={{borderBottom: `1px solid ${app.theme.primary}`}}>Lorem Ipsum</li>
                </ul> */}
            
                <h5 className='mt-2 text-center'> { state?.pregunta } </h5>
                <Button
                    className=""
                    onClick={handleClickejecutivo}
                >
                    { state?.respuesta }
                </Button>
          

            </div>

        </div>

      </ClickAwayListener>
    }

     <Button
        style={{
            width:'80px',
            height: '80px',
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 10,
            borderRadius: '50%',
            padding: '8px',
            cursor: 'pointer'
          }}
        className=""
        onClick={() => {
            setModal(!showmodal);
        }}
    >
       {
            showmodal 
            ? <AiOutlineClose className='animate__animated animate__fadeIn' size={50} />
            : <BiMessageDetail className='animate__animated animate__fadeIn' size={50} />
    
       } 

    </Button>
    <Loading estilo={showLoading} boton_helper={true}/>
    <Modal show={show} centered>
        <ModalHeader className='justify-content-center'><img src={Laptop} alt="laptop" /></ModalHeader>
        <ModalBody className='text-center'>
            <TextColored
                size={app?.theme?.font?.body32}
                children={
                    'Mensaje enviado'
                }
                type={app?.theme?.gray}
            />
            <Row className="d-flex justify-content-center align-items-center">
                <Col md={5}>
                <CustomButton
                    children='OK'
                    onClick={()=>setShow(false)}
                />
                </Col>
            </Row>
        </ModalBody>
    </Modal>   
    </>
  )
}
